import React from 'react';
import { Auth0Provider } from './auth';

function AppProviders({ children }) {
  return <Auth0Provider
  >{children}</Auth0Provider>;
}

export default AppProviders;
